export function detectControls(code = '') {
  const meta = code.match(/name=["']titan-controls["']\s+content=["'](\w+)["']/i);
  if (meta) return meta[1];
  if (/TITAN\.input\.a[xy]|T\.input\.a[xy]|mousemove|pointermove|atan2/.test(code)) return 'stick';
  if (/keydown|keyup/.test(code)) return 'dpad';
  if (/click|touchstart|pointerdown|mousedown/.test(code)) return 'tap';
  return 'dpad';
}

const SECTIONS = {
  init: /^(init|setup|start|reset|create|load|boot|resize|build)/i,
  update: /^(update|step|tick|physics|move|collide|spawn|logic)/i,
  render: /^(render|draw|paint|frame|loop)/i,
  controls: /^(key|input|handle|on[A-Z]|control|tap|press|pointer|touch|mouse)/i,
};

export function analyzeCode(code = '') {
  const fns = new Set();
  const re = /function\s+([A-Za-z_$][\w$]*)\s*\(|(?:const|let|var)\s+([A-Za-z_$][\w$]*)\s*=\s*(?:async\s*)?(?:function|\([^)]*\)\s*=>|[A-Za-z_$]\w*\s*=>)/g;
  let m;
  while ((m = re.exec(code))) fns.add(m[1] || m[2]);
  const classes = [...code.matchAll(/class\s+([A-Z][\w$]*)/g)].map((x) => x[1]);
  const listeners = [...new Set([...code.matchAll(/addEventListener\(\s*['"](\w+)['"]/g)].map((x) => x[1]))];
  const sections = { init: [], update: [], render: [], controls: [] };
  for (const f of fns) for (const [k, r] of Object.entries(SECTIONS)) if (r.test(f)) { sections[k].push(f); break; }
  sections.controls.push(...listeners.filter((l) => /key|pointer|touch|mouse|click|gamepad/.test(l)).map((l) => `on:${l}`));
  return {
    lines: code.split('\n').length,
    bytes: new Blob([code]).size,
    renderer: /getContext\(\s*['"]webgl2/.test(code) ? 'WebGL 2.0' : /getContext\(\s*['"](webgl|experimental-webgl)/.test(code) ? 'WebGL' : /getContext\(\s*['"]2d/.test(code) ? 'Canvas 2D' : 'DOM',
    functions: [...fns],
    classes,
    listeners,
    sections,
    controls: detectControls(code),
    titan: /TITAN/.test(code),
    audio: /AudioContext|T\.sfx|TITAN\.sfx/.test(code),
  };
}

export function extractScript(code = '') {
  const parts = [...code.matchAll(/<script(?![^>]*\bsrc=)[^>]*>([\s\S]*?)<\/script>/gi)].map((x) => x[1].trim());
  return parts.length ? parts.join('\n\n') : code;
}

export function extractTitle(code = '', fallback = 'Gioco senza nome') {
  const t = code.match(/<title>([^<]{1,60})<\/title>/i);
  return t ? t[1].trim() : fallback;
}
